import {useSelector} from 'react-redux';
import {selectTutorialChapterId, selectTutorialState} from '../../redux/reducers/privateStateReducer/selectors';
import {getTutorialChapter} from '../../configs/tutorial';

/**
 * UI-флаги активной главы обучения (скрытие рынка политик, перехвата
 * инициативы). Вне обучения — все флаги false, интерфейс обычный.
 */
export const useTutorialUiFlags = () => {
  const chapterId = useSelector(selectTutorialChapterId);
  const chapter = getTutorialChapter(chapterId);
  return {
    isTutorialActive: Boolean(chapter),
    hidePolicyMarket: Boolean(chapter?.ui?.hidePolicyMarket),
    hideInitiativeInterception: Boolean(chapter?.ui?.hideInitiativeInterception),
  };
};

/**
 * Показана ли кнопка отмены действия (UndoButton) в обучении: до шага
 * знакомства с ней (step.revealsUndoButton) кнопка скрыта. Главы, где
 * кнопка знакома с самого начала, ставят ui.undoButtonRevealed. Вне
 * обучения — всегда true. Селектор-функция: пригодна для useSelector.
 */
/**
 * Разрешена ли РЕАЛЬНАЯ отмена действия на текущем шаге обучения: шаг
 * знакомства с кнопкой просит игрока откатить постройку (allow: 'undo').
 * На остальных шагах кнопка отвечает подсказкой «отмена недоступна» —
 * сценарии глав выверены и отката не переживут. Селектор для useSelector
 */
export const checkIfTutorialUndoAllowed = (state) => {
  const tutorialState = selectTutorialState(state);
  const chapter = getTutorialChapter(tutorialState.chapterId);
  if (!chapter || tutorialState.isChapterCompleted) {
    return false;
  }
  const step = chapter.steps[tutorialState.stepIndex];
  return Boolean(step?.allow?.some((declaration) => declaration.action === 'undo'));
};

export const checkIfTutorialUndoButtonRevealed = (state) => {
  const tutorialState = selectTutorialState(state);
  const chapter = getTutorialChapter(tutorialState.chapterId);
  if (!chapter) {
    return true;
  }
  if (chapter.ui?.undoButtonRevealed) {
    return true;
  }
  const revealStepIndex = chapter.steps.findIndex((step) => step.revealsUndoButton);
  if (revealStepIndex === -1) {
    return false;
  }
  return tutorialState.stepIndex >= revealStepIndex;
};
